import React from "react";
import C3Chart from "react-c3js";
import clientService from "../../../services/client";
import ChartDateRangeForm from "./ChartDateRangeForm";
import AnalyticsChartCard from "./AnalyticsChartCard";
import ContextServicePills from "./ContextServicePills";
import { defaultStartDate, rotatedBarAxis, emptyBarChart } from "./chartUtils";

export default class AgentStatsChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: defaultStartDate(),
      endDate: new Date(),
      contextKey: [],
      chartData: emptyBarChart("Total Chats", "#662C8F"),
    };
  }

  componentDidMount() {
    this.fetchData(this.state.startDate, this.state.endDate);
  }

  async fetchData(startDate, endDate) {
    const chartData = emptyBarChart("Total Chats", "#662C8F");
    try {
      const res = await clientService.getAgentChats(
        startDate,
        endDate,
        this.state.contextKey,
      );
      if (res.data && res.data.result && res.data.result.length) {
        chartData.columns = [
          ["x", ...res.data.result.map((m) => m.name)],
          ["Total Chats", ...res.data.result.map((m) => m.totalChats)],
        ];
      }
    } catch (err) {
      console.error(err);
    }
    this.setState({ chartData });
  }

  toggleContext = (key) => {
    const { contextKey } = this.state;
    const nextKeys =
      contextKey.indexOf(key) < 0
        ? contextKey.concat(key)
        : contextKey.filter((item) => item !== key);
    this.setState({ contextKey: nextKeys }, () =>
      this.fetchData(this.state.startDate, this.state.endDate),
    );
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.fetchData(this.state.startDate, this.state.endDate);
  };

  render() {
    return (
      <React.Fragment>
        <ChartDateRangeForm
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onStartChange={(date) => this.setState({ startDate: date })}
          onEndChange={(date) => this.setState({ endDate: date })}
          onSubmit={this.handleSubmit}
          layout="inline"
        />
        <div className="col col-12 col-sm-12 col-lg-12" />
        <AnalyticsChartCard
          title="Agent Stats"
          cardClassName="box-3rd card card101"
          wrapCol={false}
          headerRight={
            <ContextServicePills
              contexts={this.props.contexts}
              onSelect={this.toggleContext}
            />
          }
        >
          <C3Chart
            size={{ height: 500 }}
            bar={{ width: 50 }}
            padding={{ left: 100 }}
            data={this.state.chartData}
            axis={rotatedBarAxis}
            legend={{ show: true }}
          />
        </AnalyticsChartCard>
      </React.Fragment>
    );
  }
}
